import { apiClient } from "../../../services/api";

// Where the follow-up suggestions come from: the article-scoped CWYOP endpoint
// or the general-chat endpoint. Both return `{ followUpQuestions: string[] }`.
export type FollowUpSource =
  { kind: "article"; articleId: string } | { kind: "general" };

export async function fetchFollowUpQuestions(
  source: FollowUpSource,
  query: string,
  answer: string
): Promise<string[]> {
  try {
    if (source.kind === "article") {
      const res = await apiClient.post(
        "/webapp/private/articles/:id/chat-with-paper/follow-up-questions",
        { param: { id: source.articleId }, json: { query, answer } }
      );
      return res.body.followUpQuestions;
    }
    const res = await apiClient.post(
      "/webapp/private/conversations/follow-up-questions",
      { json: { query, answer } }
    );
    return res.body.followUpQuestions;
  } catch {
    return [];
  }
}
